import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarryoverTagComponent } from '../../route-recommendations/route-itinerary/components/carryover-tag/carryover-tag.component';
import { EvTagComponent } from '../../route-recommendations/route-itinerary/components/ev-tag/ev-tag.component';
import { TravelSchedulerTask } from '../../../interfaces/travel-scheduler/travel-scheduler-task';
import { TravelSchedulerSummaryTaskComponent } from '../travel-scheduler-summary-task/travel-scheduler-summary-task.component';
import { VmePipesModule } from '../../../vme-pipes.module';

@Component({
  selector: 'travel-scheduler-summary',
  standalone: true,
  imports: [
    CommonModule,
    CarryoverTagComponent,
    EvTagComponent,
    TravelSchedulerSummaryTaskComponent,
    VmePipesModule,
  ],
  templateUrl: './travel-scheduler-summary.component.html',
  styleUrls: ['./travel-scheduler-summary.component.css'],
})
export class TravelSchedulerSummaryComponent implements OnInit, OnChanges {
  carryoverCount: number = 0;
  @Input() evCount: number = 0;
  @Input() jobNumber: string = '';
  @Input() tasks!: TravelSchedulerTask[];
  @Output() editScheduleClicked = new EventEmitter<number>();

  constructor() {}

  ngOnInit(): void {}

  protected totalDurationHours = 0;
  protected totalMileage = 0;
  protected startDate: Date;
  protected endDate: Date;
  ngOnChanges(changes: SimpleChanges) {
    this.totalDurationHours = Number(
      (this.tasks.reduce((a, b) => a + b.taskDurationMinutes, 0) / 60).toFixed(1),
    );
    this.totalMileage = Number(this.tasks.reduce((a, b) => a + b.taskMileage, 0).toFixed(1));
    this.startDate = new Date(this.tasks[0].supplierPickupWindow);
    this.endDate = new Date(this.tasks[this.tasks.length - 1].supplierDropoffWindow);

    if (this.startDate.getDate() == this.endDate.getDate()) {
      this.endDate = null;
    }

    this.carryoverCount = this.tasks.filter((x) => x.isSupplierCarryingover).length;
    this.summaryText = this.getSummaryText();
  }

  handleEditSchedule($event: number) {
    this.editScheduleClicked.emit($event);
  }

  protected summaryText: string = '';
  getSummaryText() {
    const taskLabel = this.tasks?.length == 1 ? 'Task' : 'Tasks';
    const durationLabel = this.totalDurationHours == 1 ? 'Hour' : 'Hours';

    return `${this.tasks?.length} ${taskLabel} - ${this.totalDurationHours} ${durationLabel} - ${this.totalMileage} Miles`;
  }
}
